import { useState } from "react";
import { useForm } from "react-hook-form";

import AuthService from "@/components/auth/service";

interface Verify {
	email: string;
}

export default function VerifyRequest() {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<Verify>();
	const [error, setErrors] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [success, setSuccess] = useState(false);

	const onSubmit = async (form_data) => {
		//event.preventDefault();
		setIsLoading(true);

		await AuthService.request_verify(form_data.email)
			.then((res) => {
				setIsLoading(false);
				setSuccess(true);
			})
			.catch((err) => {
				//console.log("err", err);
				setIsLoading(false);
				if (err.response.status === 500) {
					setErrors("Error: server error");
					return;
				}
			});
	};

	return (
		<>
			<div className={"container sign-in-form"}>
				<div className="card" style={{ width: "18rem", margin: "10px auto" }}>
					<div className="card-body">
						<h5 className="card-title">Request Verification</h5>
						{success ? (
							<div className="alert alert-success">
								If you registered with this email, you can verify your email address by clicking on
								the link we just emailed you.
							</div>
						) : (
							<form onSubmit={handleSubmit(onSubmit)}>
								<div className="form-group  row my-3 p-3">
									<label>Email</label>
									<input {...register("email")} className={"form-control"} />
									{errors?.email?.message && (
										<div className="alert alert-danger">{errors?.email?.message}</div>
									)}
								</div>

								{error ? <div className="alert alert-danger">{error}</div> : ""}

								<div className="d-flex justify-content-end">
									{isLoading ? (
										<div className="spinner-grow text-primary" role="status">
											<span className="visually-hidden">Loading...</span>
										</div>
									) : (
										""
									)}

									<button type="submit" className="btn btn-primary">
										Request new verify link
									</button>
								</div>
							</form>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
